import { Fragment, type ReactNode } from 'react';
import { identityKey, useAuth } from '@/shared/auth';

/**
 * Ein Wechsel von Benutzer, Workspace oder Support-Sitzung baut die Arbeitsfläche neu auf. Kein
 * offener Dialog, kein Entwurf und kein Abfragebeobachter des vorigen Kontexts überlebt ihn — der
 * geleerte Cache allein erreichte Komponenten nicht, die zufällig nicht neu rendern.
 */
export function IdentityBoundary({ children }: { children: ReactNode }) {
  return <Fragment key={identityKey(useAuth().user)}>{children}</Fragment>;
}
